import angular from "angular";

/**
 * Controller for Double the Donation component.
 *
 * @param $q
 * @param $element
 * @param $window
 * @param $timeout
 * @constructor
 */
export function DoubleTheDonationController(
  $q,
  $element,
  $window,
  $timeout
) {

  /** @type {string} */
  this.publicKey = undefined;

  /**
   * Callback invoked when a company is selected.
   * @type {function({selectedCompany: DoubleTheDonationCompany}): void}
   */
  this.onCompanyChanged = undefined;

  /**
   * Callback invoked when search text changes.
   * @type {function({searchText: string}): void}
   */
  this.onTextChanged = undefined;

  this.$onInit = () => {
    const widgetContainer = $element[0].querySelector('#double-the-donation-wrapper');
    const dtdPlugin = $window.doublethedonation;

    if (dtdPlugin) {
      dtdPlugin.plugin.v2.load_streamlined_search(
        widgetContainer,
        this.publicKey,
        {
          'on_company_changed': (selectedCompany) => {
            $timeout(() => {
              this.onCompanyChanged({selectedCompany: selectedCompany});
            }, 0);
          }
        }
      );
    } else {
      console.warn('Double the Donation plugin not available');
    }
  };
}

DoubleTheDonationController.$inject = ['$q', '$element', '$window', '$timeout'];

export default angular.module('givingApp.doubleTheDonation', [])
  .component('doubleTheDonation', {
    template: require('./doubleTheDonation.html'),
    bindings: {
      publicKey: '<',
      onCompanyChanged: '&',
    },
    controller: DoubleTheDonationController
  })
  .name;
